// action type strings
import {HIDE_SNACKBAR, SHOW_SNACKBAR, SET_NAV_STATE, SHOW_SPINNER, HIDE_SPINNER, SHOW_CONTROLS, HIDE_CONTROLS, WARNING_TOAST } from '../../actionTypes';
import shortid from 'shortid';

export function setNavState(navState) {
  return {
    type: SET_NAV_STATE,
    navState
  };
}

export function hideSnackBar() {
  return {
    type: HIDE_SNACKBAR,
    showSnackBar: false,
    snackBarText: null,
    hideSnackBarAction: null
  };
}

export function showSnackBar(snackBarText = null, hideSnackBarAction = null) {
  return {
    type: SHOW_SNACKBAR,
    showSnackBar: true,
    snackBarText,
    hideSnackBarAction
  };
}

export function showSpinner() {
  return {
    type: SHOW_SPINNER,
    showSpinner: true
  };
}

export function hideSpinner() {
  return {
    type: HIDE_SPINNER,
    showSpinner: false
  };
}

export function showControls() {
  return {
    type: SHOW_CONTROLS,
    hideControls: false
  };
}

export function hideControls() {
  return {
    type: HIDE_CONTROLS,
    hideControls: true
  };
}

export function warningToast(message) {
  return {
    identifier: shortid.generate(),
    type : WARNING_TOAST,
    title: 'Warning',
    message
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/ui.js